export const categories = [
  {
    id: "kaogu",
    name: "考古旧瓜",
    desc: "翻出多年前的老话题，重新捋一遍当年没看懂的前因后果。",
    count: 128,
    icon: "ri-history-line",
  },
  {
    id: "mingchang",
    name: "名场面补档",
    desc: "那些年被反复提起的名场面，完整收录、逐帧回看。",
    count: 96,
    icon: "ri-movie-2-line",
  },
  {
    id: "quannei",
    name: "圈内合集",
    desc: "把同一时间线的零散消息串成一条完整脉络，一次看全。",
    count: 74,
    icon: "ri-links-line",
  },
  {
    id: "remen",
    name: "实时热议",
    desc: "正在被反复讨论的话题，边看边补课，不错过关键节点。",
    count: 152,
    icon: "ri-fire-line",
  },
];

export const articles = [
  {
    id: "kaogu-2016-duanzi",
    title: "考古 2016：一场被误读了整整八年的“后台对话”",
    category: "kaogu",
    categoryName: "考古旧瓜",
    summary:
      "一段当年只流传了半天的后台对话，被截取成完全不同的意思。八年后完整版本流出，很多人的印象需要重新修正。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20magazine%20illustration%20of%20a%20theater%20backstage%20corridor%20with%20vintage%20camera%20and%20spotlight%20beams%2C%20muted%20cream%20and%20terracotta%20tones%2C%20grainy%20texture%2C%20artistic%20retro%20poster%20style&width=800&height=600&seq=gua-cover-01&orientation=landscape",
    tags: ["旧闻重读", "时间线梳理", "完整版"],
    date: "2024-11-18",
    readCount: 48200,
    featured: true,
    hot: 98,
    timeline: [
      { time: "2016 年 3 月", text: "话题最初出现在一次公开活动的后台连线中，片段不足十秒。" },
      { time: "当日晚间", text: "被剪成竖屏短视频二次传播，语义与原始语境分离。" },
      { time: "2024 年 9 月", text: "完整现场录音公开，前后文补齐，原意得以还原。" },
      { time: "2024 年 11 月", text: "多方开始重新梳理当年的信息链路，形成本次合集。" },
    ],
    body: [
      "要把这桩旧事讲清楚，得先回到 2016 年那次公开活动。当时后台连线只对外放出了不到十秒的片段，剩下的内容在很长一段时间里都没有公开。恰恰是这十秒，成了后来无数版本的起点。",
      "片段流出当晚，就有人把它剪成竖版短视频，配上了完全不同的字幕。传播链条越拉越长，原始语境反而被彻底覆盖。等大多数人第一次看到这个话题时，它已经是第三手、第四手的转述了。",
      "转折出现在今年九月。一位当年参与现场记录的工作人员把完整录音整理后公开，前后文补齐之后，那句被反复引用的话其实只是一个再普通不过的流程确认。所谓“意味深长”，是剪辑加上去的。",
      "这件事对本号来说是个提醒：越是流传广的旧瓜，越要留个心眼去看原始素材。本合集把当年的发布时间、平台和关键节点都整理在时间线上，你可以自己对着看一遍。",
    ],
  },
  {
    id: "mingchang-2018-redcarpet",
    title: "名场面补档：那次红毯上被忽略的三秒钟",
    category: "mingchang",
    categoryName: "名场面补档",
    summary:
      "所有人都在讨论红毯造型，却没人注意到主镜头切走前的那三秒。补档完整素材后，这个细节成了新的讨论焦点。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20red%20carpet%20event%20with%20camera%20flashes%20and%20elegant%20silhouettes%2C%20muted%20crimson%20and%20gold%20accents%20on%20cream%20background%2C%20grainy%20retro%20poster%20texture&width=800&height=600&seq=gua-cover-02&orientation=landscape",
    tags: ["名场面", "细节控", "补档"],
    date: "2024-12-02",
    readCount: 63100,
    featured: true,
    hot: 95,
    timeline: [
      { time: "2018 年 5 月", text: "红毯直播当天，主镜头大部分时间停留在前排区域。" },
      { time: "次日", text: "讨论集中在造型与站位，无人提及镜头切换瞬间。" },
      { time: "2024 年 10 月", text: "现场多机位素材被整理，切走前的三秒被还原。" },
    ],
    body: [
      "一场红毯直播，观众看到的是导播选出来的那一路画面。而在导播切换之前，现场其实还有几组机位在同时运转，只是它们的素材从来没有公开过。",
      "今年整理现场多机位素材时，大家才第一次看到主镜头切走前的那三秒。画面里几个原本背对镜头的动作，恰好完整地交代了后来的站位变化。",
      "也正因为这三秒，当年很多“解释不通”的细节突然对上了。补档的意义大概就在这儿——它不是制造新的话题，而是把当年缺失的那块拼图放回去。",
    ],
  },
  {
    id: "quannei-2020-schedule",
    title: "圈内合集：那年临时换档，其实是一条完整的时间线",
    category: "quannei",
    categoryName: "圈内合集",
    summary:
      "临时换档、行程取消、官宣延后，当年被当成三件不相干的事。把它们排在同一条时间线上，会发现节奏其实很清晰。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20wall%20calendar%20and%20clapperboard%20with%20timeline%20arrows%2C%20muted%20olive%20green%20and%20cream%20tones%2C%20grainy%20retro%20print%20style&width=800&height=600&seq=gua-cover-03&orientation=landscape",
    tags: ["时间线", "行程梳理", "合集"],
    date: "2024-10-27",
    readCount: 35600,
    featured: false,
    hot: 82,
    timeline: [
      { time: "2020 年 7 月", text: "原定档期首次调整，官方仅以“排期优化”说明。" },
      { time: "同月中旬", text: "相关行程陆续取消，外界解读为各自的独立安排。" },
      { time: "2020 年 8 月", text: "官宣整体延后，三个事件第一次被放在一起讨论。" },
    ],
    body: [
      "单看每一条消息，都不像是大事。档期调整、行程变动、官宣延后，放在娱乐圈里几乎天天都在发生。",
      "但当把所有节点按时间排好，会发现它们之间的间隔非常规律，像是同一套安排下的连锁反应，而不是临时起意。",
      "本合集没有添加任何新说法，只是把公开的时间点整理成一条线。至于这条线指向什么，留给读者自己判断。",
    ],
  },
  {
    id: "remen-2024-variety",
    title: "实时热议：这档综艺的“沉默片段”为什么被反复回看",
    category: "remen",
    categoryName: "实时热议",
    summary:
      "节目播出后，讨论最高的不是任何一位嘉宾的高光时刻，而是一段谁都没说话的镜头。它为什么让人挪不开眼？",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20television%20studio%20set%20with%20empty%20chairs%20and%20soft%20studio%20lights%2C%20muted%20amber%20and%20cream%20palette%2C%20grainy%20retro%20poster%20texture&width=800&height=600&seq=gua-cover-04&orientation=landscape",
    tags: ["综艺", "名场面", "热议"],
    date: "2024-12-08",
    readCount: 52800,
    featured: true,
    hot: 91,
    timeline: [
      { time: "播出当晚", text: "沉默片段率先在弹幕里被集体点名。" },
      { time: "次日", text: "相关讨论登上多个平台的热门话题。" },
      { time: "第三日", text: "节目组释出更多花絮，补充了这段前后的完整语境。" },
    ],
    body: [
      "一台综艺节目，最出圈的往往是笑点或者冲突。但这一次，大家讨论最多的，是一段没有台词的安静镜头。",
      "有观众说，正是因为什么都没说，反而给了想象空间。也有人觉得，这种留白在当下的综艺节奏里太稀缺了。",
      "节目组随后放出的花絮里，这段镜头的完整语境被补齐，讨论也逐渐从“猜”转向了“看”。",
    ],
  },
  {
    id: "kaogu-2012-award",
    title: "考古 2012：颁奖礼上那个被剪掉的镜头去哪了",
    category: "kaogu",
    categoryName: "考古旧瓜",
    summary:
      "当年的颁奖礼直播里，有一个镜头在成片中被彻底剪掉。多年后完整版重见天日，答案比想象中平淡。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20an%20awards%20stage%20with%20golden%20trophy%20and%20curtain%2C%20muted%20bronze%20and%20cream%20tones%2C%20grainy%20retro%20print%20style&width=800&height=600&seq=gua-cover-05&orientation=landscape",
    tags: ["颁奖礼", "旧闻重读", "完整版"],
    date: "2024-09-30",
    readCount: 27400,
    featured: false,
    hot: 74,
    timeline: [
      { time: "2012 年 12 月", text: "颁奖礼直播进行，现场发生一段未被记录的插曲。" },
      { time: "成片上线", text: "该段内容在正式版本中被剪除，仅留下转场。" },
      { time: "2024 年 8 月", text: "现场素材整理中重新发现该段画面。" },
    ],
    body: [
      "颁奖礼的直播和最终成片，往往不是同一回事。直播讲的是现场，成片讲的是节奏，两者之间有取舍很正常。",
      "2012 年的这场颁奖礼就少了一段。当年只在现场的人提起过，之后便随着时间被淡忘。",
      "今年整理现场素材时，那段画面重新被找到。看完之后你会发现，它被剪掉的原因很朴素——当时的转场节奏装不下它。",
    ],
  },
  {
    id: "mingchang-2021-interview",
    title: "名场面补档：那句“下次再说”，其实后面还有半句",
    category: "mingchang",
    categoryName: "名场面补档",
    summary:
      "一句被引用无数次的话，其实是半句。完整片段公开后，很多人第一次知道它后面跟着什么。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20vintage%20microphone%20and%20interview%20stool%20in%20a%20warm%20lit%20room%2C%20muted%20terracotta%20and%20cream%20palette%2C%20grainy%20retro%20poster%20texture&width=800&height=600&seq=gua-cover-06&orientation=landscape",
    tags: ["采访", "名场面", "补档"],
    date: "2024-11-05",
    readCount: 41300,
    featured: false,
    hot: 85,
    timeline: [
      { time: "2021 年 4 月", text: "采访播出，其中一句回答被单独截出传播。" },
      { time: "随后数年", text: "这句话被广泛引用，但始终只有前半句。" },
      { time: "2024 年 10 月", text: "完整采访素材公开，后半句首次出现在公众视野。" },
    ],
    body: [
      "一句话之所以能流传，往往是因为它足够短、足够有画面感。但短，也就意味着容易被截断。",
      "2021 年那次采访里就有一句被截了三年的话。前半句干脆利落，后半句是对前面判断的补充说明，反而更关键。",
      "完整素材公开后，不少当年引用过这句话的人回过头来重新理解了一遍。补档的价值，有时候就是把半句话补全。",
    ],
  },
  {
    id: "quannei-2019-fans",
    title: "圈内合集：一次应援颜色的更替，如何牵出一段往事",
    category: "quannei",
    categoryName: "圈内合集",
    summary:
      "从应援色的更替聊起，最后聊回了五年前的一次活动。看似无关的两件事，中间只隔了三个月。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20glowing%20fan%20light%20sticks%20in%20a%20dark%20venue%2C%20muted%20pink%20and%20amber%20accents%20on%20cream%20grainy%20retro%20print%20style&width=800&height=600&seq=gua-cover-07&orientation=landscape",
    tags: ["应援", "时间线", "合集"],
    date: "2024-10-12",
    readCount: 19800,
    featured: false,
    hot: 66,
    timeline: [
      { time: "2019 年 3 月", text: "一次活动的视觉方案采用了新的主色调。" },
      { time: "2019 年 6 月", text: "相关应援物料陆续更换，形成新的统一风格。" },
      { time: "2024 年 9 月", text: "有读者整理旧物料时发现两次调整之间仅隔一季。" },
    ],
    body: [
      "应援颜色这种东西，外人看着都一样，圈内却一眼能分辨。颜色一换，往往意味着很多事都在同步调整。",
      "把 2019 年前后的物料按季度排开，会发现变化不是突然发生的，而是在三个月里一点点完成过渡。",
      "顺着这条线往回找，还能看到更早的一次活动留下的影子。所谓考古，就是把这种不起眼的线索接起来。",
    ],
  },
  {
    id: "remen-2024-online",
    title: "实时热议：一条深夜动态发出又删除，截图已被存了三千遍",
    category: "remen",
    categoryName: "实时热议",
    summary:
      "动态只存在了十几分钟就被删除，但截图已经在各个群里传开。讨论开始前，先看看它到底写了什么。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20glowing%20smartphone%20screen%20on%20a%20dark%20desk%20at%20night%2C%20muted%20amber%20glow%20on%20cream%20grainy%20retro%20print%20style&width=800&height=600&seq=gua-cover-08&orientation=landscape",
    tags: ["深夜动态", "截图", "热议"],
    date: "2024-12-05",
    readCount: 71500,
    featured: false,
    hot: 93,
    timeline: [
      { time: "发布后 5 分钟", text: "动态开始在粉丝社群内部流传。" },
      { time: "发布后 14 分钟", text: "原动态被删除，但截图已大量扩散。" },
      { time: "次日凌晨", text: "相关话题冲上各平台热搜位置。" },
    ],
    body: [
      "深夜发文、迅速删除，这套流程这几年被反复上演。每次的剧本都差不多，但每次还是能精准踩中大家的注意力。",
      "这次的不同点在于，动态存在的时间格外短，反而让截图显得更“珍贵”，传播速度比平时更快。",
      "在开始讨论之前，先把时间点和截图内容核对一遍。本合集把已知的节点整理在下方，后续有更新会继续补档。",
    ],
  },
  {
    id: "kaogu-2014-debut",
    title: "考古 2014：出道舞台重制高清版，藏着被忽略的走位",
    category: "kaogu",
    categoryName: "考古旧瓜",
    summary:
      "旧素材修复成高清之后，当年看不清的走位终于看得清了。有人发现，舞台的调度比想象中复杂得多。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20an%20empty%20concert%20stage%20with%20geometric%20lighting%20paths%2C%20muted%20crimson%20and%20cream%20tones%2C%20grainy%20retro%20poster%20texture&width=800&height=600&seq=gua-cover-09&orientation=landscape",
    tags: ["舞台", "高清重制", "细节控"],
    date: "2024-09-22",
    readCount: 24100,
    featured: false,
    hot: 70,
    timeline: [
      { time: "2014 年 8 月", text: "出道舞台首次公开，画质受限细节模糊。" },
      { time: "2024 年 7 月", text: "爱好者完成素材修复，输出高清版本。" },
      { time: "2024 年 9 月", text: "高清版发布后，舞台走位成为新的讨论点。" },
    ],
    body: [
      "十年前的一场舞台，画质只有当时的水平，很多细节只能看个大概。修复工作就是把这些模糊的地方补清楚。",
      "高清版本出来之后，最让人意外的不是服装或者灯光，而是舞台走位的复杂程度。在那个年代，这样的调度并不常见。",
      "有做舞台的人留言说，看高清版像在校对一份专业作业。旧素材重制，有时候比新内容信息量更大。",
    ],
  },
];

export const faqs = [
  {
    q: "「蝌蚪吃瓜」主要收录什么内容？",
    a: "本站专注整理娱乐行业的公开话题，以合集、补档和考古旧瓜为主要形态。每一条内容都会标注时间线与信息来源节点，方便你按脉络阅读，而不是只看零散片段。",
  },
  {
    q: "什么是“补档”？和普通的追热点有什么区别？",
    a: "补档是指把已经发生、但当时信息不完整的话题重新整理出来，补齐前后语境与关键素材。它不追求抢第一时间，而是争取把一件事讲完整。",
  },
  {
    q: "合集里的内容可以一直回看吗？",
    a: "可以。合集长期保留，我们也会在原有合集上继续补充新整理的节点，所以收藏一个合集之后再回来，往往能看到更完整的版本。",
  },
  {
    q: "站内内容会标注信息来源吗？",
    a: "会。涉及时间线的内容，我们尽量标注公开节点。对于无法核实的说法，我们会明确区分“流传版本”和“已确认信息”，不做混淆。",
  },
  {
    q: "如何推荐一个值得考古的旧话题？",
    a: "你可以到「联系我们」页面留言，附上话题名称和你记得的关键时间点。整理团队会评估信息完整度，合适的会排入考古计划。",
  },
];

export const testimonials = [
  {
    name: "老瓜农阿哲",
    role: "连续回看用户",
    text: "以前追热点都是看过就忘，这里把时间线排好之后，很多当年没看懂的事一下就串起来了。",
  },
  {
    name: "夜猫编辑部",
    role: "内容整理爱好者",
    text: "补档做得比想象中严谨，会区分已确认和流传版本，这点很加分。",
  },
  {
    name: "蹲守小队长",
    role: "合集收藏用户",
    text: "收藏了三个合集，过段时间回来还能看到补充的节点，这种长期维护的感觉很踏实。",
  },
];

export const stats = [
  { label: "收录合集", value: "450+" },
  { label: "完成补档", value: "1,280" },
  { label: "考古话题", value: "3,600" },
  { label: "回看次数", value: "920 万" },
];